<template>
  <div class="footer">
		<div class="row6">
			<el-row type="flex" justify="space-between">
				<el-col :span="12">
				<ul class="contact-details">
					<li>客服电话：<b>4009692919</b></li>
					<li>邮箱地址：<b>400@piaorpa.com</b></li>
					<li>周一～周五 10:00 - 18:00</li>
				</ul>
				</el-col>
				<el-col :span="12">
				<ul class="codes">
					<li>
					<p class="code-title">公众号</p>
					<div class="code-img"><img src="@/assets/home/public-ocde.png" alt="" srcset=""></div>
					</li>
					<li>
					<p class="code-title">小程序</p>
					<div class="code-img"><img src="@/assets/home/applets-code.png" alt="" srcset=""></div>
					</li>
				</ul>
				</el-col>
			</el-row>
			<div class="copyright">© 2020 Sanfeng <a class="record" href="http://www.beian.miit.gov.cn" target="_blank">粤ICP备19034893号-2</a></div>
		</div>
  </div>
</template>

<script>
export default {
  name: 'foot'
}
</script>

<style lang="less" scoped>
.footer {
	width: 100%;
	background: rgba(248,248,248,1);
	margin-top: 1rem;
	position: relative;
	z-index: 9;
	.copyright {
		padding: .36rem;
		text-align: center;
	}
 .row6 {
		max-width: 12rem;
		margin: auto!important;
		font-size: .14rem;
		color: #666;
		.contact-details {
			margin-top: 1rem;
			li {
				margin-bottom: .15rem;
				font-size: .14rem;
				color: #666;
				b {
					font-size: .18rem;
					color: #333;
					font-weight: 400;
				}
			}
		}
		.codes {
			display: flex;
			justify-content: flex-end;
			margin-top: .54rem;
			li {
				margin-right: .3rem;
			}
			.code-title {
				margin-bottom: .15rem;
				text-align: center;

			}
			.code-img {
				width: .9rem;
				height: .9rem;
			}
		}
	}
	.record {
		color: #666;
		&:hover {
			border-bottom: 1px solid #666;
		}
	}
}
@media (max-width:768px) {
	.footer {
		.row6 {
			width: 100%;
			.contact-details {
				width: 100%;
				margin-top: .5rem;
				margin-left: .14rem;
				li {
					font-size: .24rem;
					b {
						font-size: .26rem;
					}
				}
			}
			.codes li {
				margin-right: 10px;
				font-size: .24rem;
			}
			.codes {
				.code-img {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 1rem;
					height: 1rem;
					img {
						width: 100%;
					}
				}
			}
			.copyright {
				font-size: .24rem;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue